export default __webpack_public_path__ + "static/media/kitchen3-afterB-768w.1ced2068.png";